import { useState } from "react";
import {
  RiUserLine,
  RiAddLine,
  RiSearchLine,
  RiFilterLine,
  RiMailLine,
  RiPhoneLine,
  RiMapPinLine,
  RiEditLine,
  RiDeleteBinLine,
  RiFileTextLine,
  RiDownloadLine,
  RiUploadLine,
} from "react-icons/ri";

const Customers = () => {
  const [customers, setCustomers] = useState([
    {
      id: 1,
      name: "Tech Solutions Inc",
      email: "contact@techsolutions.com",
      phone: "+91 9876543210",
      address: "Mumbai",
      totalInvoices: 12,
      totalSpent: 24999.99,
      status: "Active",
      lastInvoice: "2024-02-20",
    },
    {
      id: 2,
      name: "Design Studio Pro",
      email: "hello@designstudio.com",
      phone: "+91 9876533210",
      address: "Mumbai",
      totalInvoices: 8,
      totalSpent: 12499.99,
      status: "Active",
      lastInvoice: "2024-02-15",
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("all");

  const customerStats = {
    total: customers.length,
    active: customers.filter((c) => c.status === "Active").length,
    totalRevenue: customers.reduce((sum, c) => sum + c.totalSpent, 0),
    averageSpent:
      customers.reduce((sum, c) => sum + c.totalSpent, 0) / customers.length,
  };

  const handleExportCustomers = () => {
    // Implement CSV export
    console.log("Exporting customers...");
  };

  const handleImportCustomers = () => {
    // Implement CSV import
    console.log("Importing customers...");
  };

  return (
    <div className="max-w-full mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">
          Customer Management
        </h1>
        <button className="btn btn-primary flex items-center gap-2">
          <RiAddLine className="w-5 h-5" />
          Add Customer
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">
            Total Customers
          </h3>
          <p className="text-2xl font-bold text-primary-600 mt-2">
            {customerStats.total}
          </p>
          <p className="text-sm text-gray-500 mt-1">
            {customerStats.active} active
          </p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">Total Revenue</h3>
          <p className="text-2xl font-bold text-green-600 mt-2">
            ${customerStats.totalRevenue.toFixed(2)}
          </p>
          <p className="text-sm text-gray-500 mt-1">from all customers</p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">Average Spent</h3>
          <p className="text-2xl font-bold text-blue-600 mt-2">
            ${customerStats.averageSpent.toFixed(2)}
          </p>
          <p className="text-sm text-gray-500 mt-1">per customer</p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">
            Customer Health
          </h3>
          <p className="text-2xl font-bold text-purple-600 mt-2">85%</p>
          <p className="text-sm text-gray-500 mt-1">satisfaction rate</p>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="card">
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <div className="flex-1 max-w-md relative">
            <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search customers..."
              className="input pl-10 w-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex gap-3">
            <button
              className="btn btn-secondary flex items-center gap-2"
              onClick={() => setShowFilters(!showFilters)}
            >
              <RiFilterLine className="w-5 h-5" />
              Filters
            </button>
            <button
              className="btn btn-secondary flex items-center gap-2"
              onClick={handleExportCustomers}
            >
              <RiDownloadLine className="w-5 h-5" />
              Export
            </button>
            <button
              className="btn btn-secondary flex items-center gap-2"
              onClick={handleImportCustomers}
            >
              <RiUploadLine className="w-5 h-5" />
              Import
            </button>
          </div>
        </div>

        {showFilters && (
          <div className="mt-4 pt-4 border-t grid grid-cols-1 md:grid-cols-4 gap-4">
            <select
              className="input"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">All Statuses</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            {/* More filters as needed */}
          </div>
        )}
      </div>

      {/* Customers Table */}
      <div className="card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-4 px-4">Customer</th>
                <th className="text-left py-4 px-4">Contact</th>
                <th className="text-left py-4 px-4">Total Invoices</th>
                <th className="text-left py-4 px-4">Total Spent</th>
                <th className="text-left py-4 px-4">Last Invoice</th>
                <th className="text-left py-4 px-4">Status</th>
                <th className="text-right py-4 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id} className="border-b">
                  <td className="py-4 px-4">
                    <div>
                      <div className="font-medium">{customer.name}</div>
                      <div className="text-sm text-gray-500">
                        {customer.address}
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <div>
                      <div className="flex items-center gap-1">
                        <RiMailLine className="text-gray-400" />
                        {customer.email}
                      </div>
                      <div className="flex items-center gap-1">
                        <RiPhoneLine className="text-gray-400" />
                        {customer.phone}
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-4">{customer.totalInvoices}</td>
                  <td className="py-4 px-4">
                    ${customer.totalSpent.toFixed(2)}
                  </td>
                  <td className="py-4 px-4">
                    {new Date(customer.lastInvoice).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        customer.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {customer.status}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex justify-end gap-2">
                      <button
                        title="View Invoices"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiFileTextLine className="w-5 h-5" />
                      </button>
                      <button
                        title="Edit"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiEditLine className="w-5 h-5" />
                      </button>
                      <button
                        title="Delete"
                        className="p-2 hover:bg-gray-100 rounded-lg text-red-600"
                      >
                        <RiDeleteBinLine className="w-5 h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Customers;
